/**
 * LogoutButton
 */
import * as React from 'react';
import { connect } from 'react-redux';

// Components
import ButtonLink from '../ButtonLink';

// Actions
// @ts-ignore
import { resetState } from '../../services/auth/actions';

interface Props {
    resetState: Function;
}

export class LogoutButton extends React.PureComponent<Props> {
    handleClick = (): void => {
        this.props.resetState();
    };

    render(): React.ReactElement {
        return <ButtonLink onClick={this.handleClick}>Logout</ButtonLink>;
    }
}

export default connect(null, { resetState })(LogoutButton);
